export class CumulativeRainfallDTO {
  constructor(readonly cumulativeTimeMinutes: number, readonly cumulAggregationTimeMinutes: number) {}
}
